"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { applyPerfDebugQueryParam, usePerfDebugEnabled } from "@/lib/perfDebugMode";
const PerfDebugOverlay = dynamic(() => import("./PerfDebugOverlay"), {
  ssr: false
});
export function PerfDebugMount() {
  const $ = _c(2);
  const enabled = usePerfDebugEnabled();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  if (!enabled) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ErrorBoundary fallback={null}><PerfDebugOverlay /></ErrorBoundary>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp() {
  return applyPerfDebugQueryParam(window.location.search);
}